import { Injectable } from "@angular/core";
import { excludeUrls } from "src/constants/constants";

@Injectable({
  providedIn: "root",
})
export class LoaderAppService {
  public loader: any = {
    show: false,
    pendingService: 0,
  };

  constructor() {}

  /**
   * Function to show loader
   */
  showLoader(url?: string) {
    document.body.style.overflow = "hidden";
    let excludedUrls = excludeUrls.filter(
      (element) => !!(url && url.includes(element))
    );
    if (!(excludedUrls.length > 0)) {
      this.loader.show = true;
      this.loader.pendingService += 1;
    }
  }

  /**
   * Function to hide loader
   */
  hideLoader(url?: any) {
    const excludedUrls = excludeUrls.find((element) => element.includes(url));
    document.body.style.overflow = "auto";
    if (!!excludedUrls) {
      return;
    }

    this.loader.pendingService -= 1;

    if (this.loader.pendingService <= 0) {
      this.loader.show = false;
      this.loader.pendingService = 0;
      return;
    }
  }
}
